import { useQuery } from "@tanstack/react-query";
import { useAuthFetch } from "../../../utils/useAuthFetch";
import { useWorkspaceContext } from "../../../providers/WorkspaceProvider";

export interface AggregateRequest {
  group_by: string[];
  // A second group: one series per distinct value (API ViewAggregateRequest.series_field).
  series_field?: string;
  measures: Array<{ key: string; aggregation: string; field?: string }>;
}

export interface AggregateResponse {
  current: Array<{
    keys: Record<string, unknown>;
    values: Record<string, number | null>;
  }>;
  comparison: Array<{
    keys: Record<string, unknown>;
    values: Record<string, number | null>;
  }>;
}

export function useViewAggregateQuery(
  viewId: string | undefined,
  request: AggregateRequest | null,
  enabled: boolean,
  canvasId?: string | null,
) {
  const authFetch = useAuthFetch();
  const { workspace } = useWorkspaceContext();
  const workspaceId = workspace?.id || "";
  return useQuery<AggregateResponse>({
    queryKey: ["viewAggregate", workspaceId, viewId, request, canvasId],
    queryFn: () =>
      authFetch(
        `/api/workspace/myvault/view-rows/${viewId}/aggregate${canvasId ? `?canvas_id=${encodeURIComponent(canvasId)}` : ""}`,
        "fetch view aggregate",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Workspace-Id": workspaceId,
          },
          body: JSON.stringify(request),
        },
      ),
    enabled: enabled && !!workspaceId && !!viewId && !!request,
    staleTime: 30_000,
  });
}
